module.exports = __webpack_public_path__ + "img/empty.0126f2df.png";